import type { CSSProperties, ReactElement } from "react";

import "./border-beam.css";

/**
 * FD-CAN-21 — the working border beam (see border-beam.css for the sweep
 * law). The anchor must be `position: relative` with a border-radius; the
 * beam inherits the radius and paints only the ring.
 *
 * Decorative by contract: the element is aria-hidden because meaning never
 * lives only in motion — the anchor carries a redundant still signal.
 */
export function BorderBeam({
  color,
  className = "",
}: {
  /** CSS color for the sweep head (typically the anchor's own accent
   * token — FD-CAN-13: hue is identity). Defaults to currentColor. */
  readonly color?: string;
  readonly className?: string;
}): ReactElement {
  return (
    <span
      aria-hidden="true"
      className={`ncl-border-beam ${className}`}
      data-border-beam=""
      style={color === undefined ? undefined : ({ "--ncl-beam-color": color } as CSSProperties)}
    />
  );
}
